"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Routes_1 = __importDefault(require("./Routes"));
var navState_1 = require("./contexts/navState");
var DialogService_1 = require("./contexts/DialogService");
var NotificationService_1 = require("./contexts/NotificationService");
require("../css/main.scss");
require("mobx-react-lite/batchingForReactDom");
var App = function () {
    return (react_1.default.createElement("div", { className: "app" },
        react_1.default.createElement(navState_1.NavStateProvider, null,
            react_1.default.createElement(DialogService_1.ConfirmationServiceProvider, null,
                react_1.default.createElement(NotificationService_1.NotificationServiceProvider, null,
                    react_1.default.createElement(Routes_1.default, null))))));
};
exports.default = App;
